import { Pipe, PipeTransform } from '@angular/core';

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp', '.heic'];
const NON_IMAGE_EXTENSIONS = ['.pdf', '.csv', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.zip', '.mp4', '.mov', '.mp3'];

@Pipe({
  name: 'isImageUrl',
  standalone: true,
  pure: true
})
export class IsImageUrlPipe implements PipeTransform {

  transform(url: string): boolean {
    if (!url) {return false;}
    if (url.startsWith('data:image')) {return true;}
    if (url.includes('message-thread-photo/')) {return true;}
    if (url.includes('/Media/ME')) {return true;}
    try {
      const pathname = new URL(url).pathname.toLowerCase();
      if (IMAGE_EXTENSIONS.some(ext => pathname.endsWith(ext))) {return true;}
      if (url.includes('message-thread-file/')) {
        const filename = pathname.split('/').pop() || '';
        const hasExtension = filename.includes('.') && filename.lastIndexOf('.') > 0;
        if (!hasExtension) {return true;}
        return !NON_IMAGE_EXTENSIONS.some(ext => pathname.endsWith(ext));
      }
      return false;
    } catch {
      return false;
    }
  }
}
